import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { STREAMING_LINKS } from "@/data/links";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const StreamingLinks = () => {
  return (
    <section
      data-testid="streaming-section"
      className="relative mx-auto max-w-5xl px-6 pb-32 pt-8 sm:pb-44"
    >
      <motion.p
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={0}
        className="font-accent mb-12 text-center text-[0.62rem] uppercase tracking-[0.45em] text-[#a39e8f] sm:mb-16"
      >
        Choose Your Chapel
      </motion.p>

      <div className="border-t border-white/10" data-testid="streaming-links">
        {STREAMING_LINKS.map((link, i) => (
          <motion.a
            key={link.id}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`stream-link-${link.id}`}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-40px" }}
            custom={i}
            className="group relative flex items-center justify-between gap-6 border-b border-white/10 py-7 outline-none transition-colors duration-500 hover:border-[#c9a227]/40 focus-visible:border-[#c9a227] sm:py-9"
          >
            {/* Gold wash on hover */}
            <span className="pointer-events-none absolute inset-0 origin-left scale-x-0 bg-gradient-to-r from-[#c9a227]/[0.07] to-transparent transition-transform duration-500 ease-out group-hover:scale-x-100" />

            <div className="relative flex items-baseline gap-5 sm:gap-8">
              <span className="font-accent text-xs tracking-[0.25em] text-[#c9a227]/70 transition-colors duration-500 group-hover:text-[#c9a227]">
                {link.index}
              </span>
              <span className="font-serif-display text-[1.75rem] leading-none text-[#e8e3d2] transition-all duration-500 ease-out group-hover:translate-x-2 group-hover:text-[#f3edda] sm:text-[3rem] lg:text-[3.75rem]">
                {link.label}
              </span>
            </div>

            <span className="relative flex items-center gap-4">
              <span className="hidden font-accent text-[0.6rem] uppercase tracking-[0.3em] text-[#a39e8f] opacity-0 transition-opacity duration-500 group-hover:opacity-100 md:inline">
                {link.platform}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-[#a39e8f] transition-all duration-500 group-hover:border-[#c9a227] group-hover:text-[#c9a227] sm:h-14 sm:w-14">
                <ArrowUpRight
                  className="h-5 w-5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 sm:h-6 sm:w-6"
                  strokeWidth={1.25}
                />
              </span>
            </span>
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default StreamingLinks;
